/**
 * useConsentPreference — Thin consumer of ConsentContext
 *
 * Provides consent state and actions to any component in the tree.
 * All logic lives in ConsentContext — this hook is just the accessor.
 *
 * @returns {Object} Consent context value
 * @returns {Object|null} consent - { analytics, functional, marketing } or null (first visit)
 * @returns {string|null} sessionToken
 * @returns {string} policyVersion
 * @returns {Function} setConsent - Set per-category consent
 * @returns {Function} acceptAll - Accept all categories
 * @returns {Function} rejectAll - Reject all categories
 * @returns {Function} openPreferences - Open preferences panel
 * @returns {boolean} isPanelOpen
 * @returns {Function} closePrefPanel - Close preferences panel
 *
 * @epic MVP 0.1.1.2 — Cookie Consent & Preference Layer
 * @story SCRUM-1446
 */

import { useContext } from 'react';
import { ConsentContext } from '../contexts/ConsentContext';

export default function useConsentPreference() {
  const context = useContext(ConsentContext);
  if (!context) {
    throw new Error('useConsentPreference must be used within a ConsentProvider');
  }
  return context;
}
